import React from 'react';
import { useNumberFormat } from 'hooks';

export default function CartTotal({total}) {
  const {format} = useNumberFormat();

  return (
    <>
      {total > 0 &&
        <div className="app-cart-total">
          <div className="app-cart-line">
            <div className="app-cart-line-left">
              <span className="app-cart-text-parameter-total">Total</span>
            </div>
            <div className="app-cart-line-right">
              <span className="app-cart-text-value-total">${format(total)}</span>
            </div>
          </div>
        </div>
      }
    </>
  )
}
